// @flow
import { themeStyle } from '../colorPalettes'
import { darkTheme } from './darkTheme'
import type { ThemeType } from '..'

const name = 'tvanetplay'

export const themeTvanetplay: ThemeType = {
  name,
  getThemeVariation: (themeVariation: string) => {
    switch (themeVariation) {
      case themeStyle.dark:
        return darkTheme
      default:
        return darkTheme
    }
  },
}
